import React from 'react';
import styles from './shSelectionButton.module.scss';

import SelectedSVG from "../../public/icons/selected.svg";
import UnselectedSVG from "../../public/icons/unselected.svg";

const ShSelectionButton = ({
                                  className = '',
                                  children,
                                  checked,
                                  checkedChange = () => { }
                              }: any ) => {

    return <div className={styles.button + " d-flex align-items-center mb-3 px-3 " + className + " " + (checked && styles.checked)}
                onClick={ () => { checkedChange(); } }>

        { checked && <SelectedSVG className={"svg-small svg-green"} /> }
        { !checked && <UnselectedSVG className={"svg-small opacity-50"} /> }

        <div className={"d-flex align-items-center justify-content-between w-100"}>
            { children }
        </div>

    </div>

};

export default ShSelectionButton;
